import Dashboard from '../containers/dashboard'
import PaymentToReviewDetailsManagement from '../containers/payment-to-review-details-management'

const PaymentToReviewDetails = () => {
  return (
    <Dashboard>
      <PaymentToReviewDetailsManagement />
    </Dashboard>
  )
}

export default PaymentToReviewDetails
